import { Loader } from 'modules/Loader';
import { Typography } from 'modules/Typography';
import { useTransitionState } from 'modules/hooks/useTransitionState';
import { Container, LoaderContainer, ContentContainer, Overlay } from './styled';
const sizes = {
    small: 12,
    medium: 18,
};
export function LoaderOverlay(props) {
    const { children, enabled = true, transparent = false, width = '100%', height = '100%', hideLoader = false, loaderSize = 'medium', position = 'center', label, } = props;
    const transitionState = useTransitionState(enabled, 200);
    const showOverlay = transitionState !== 'hidden';
    return (<Container $width={width} $height={height}>
      <ContentContainer $transparent={transparent} $enabled={enabled}>
        {children}
      </ContentContainer>
      {showOverlay && <Overlay $enabled={enabled} $transparent={transparent}/>}
      {showOverlay && !hideLoader && (<LoaderContainer $enabled={enabled} $position={position}>
          <Loader size={sizes[loaderSize]}/>
          {label && (<Typography $fontSize={loaderSize} $fontWeight="medium" $appearance="100">
              {label}
            </Typography>)}
        </LoaderContainer>)}
    </Container>);
}
